import { Snackbar, SnackbarContent } from "@mui/material";
import React from "react";
import { MdOutlineCancel } from "react-icons/md";

const QuestionSnackbar = ({ requiredQuestions, open, onClose }) => {
	const handleClose = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		onClose();
	};
	return (
		<Snackbar
			anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
			open={open}
			autoHideDuration={8000}
			onClose={handleClose}
		>
			<SnackbarContent
				sx={{
					backgroundColor: "#6D0000", // background color
					width: "220px",
					// overflowY: "auto", // scroll when overflowing
					position: "relative", // required for absolute positioning inside
					paddingTop: "30px",
				}}
				message={
					<div className="overflow-y-auto max-h-[180px]">
						<h2 className="text-base mb-3 font-medium">
							Missing Required Questions
						</h2>
						<p className="text-sm">
							You have missed some required questions. Please
							answer all required fields before submitting.
							Thank you!
						</p>
						<button
							onClick={handleClose}
							className="bg-white border-0 rounded-md text-primary px-4 py-1 mt-3"
						>
							close
						</button>
					</div>
				}
				action={
					<button
						onClick={handleClose}
						className="bg-transparent border-0 rounded-md text-white my-2 mx-2 absolute top-0 right-0"
					>
						<MdOutlineCancel size={28} />
					</button>
				}
			/>
		</Snackbar>
	);
};

export default QuestionSnackbar;
